export default __webpack_public_path__ + "media/images/footer/mastercard-61fe0c4cf3ba50dcf7ce7bd6ab15cb43.svg";